/**
 * Loading Screen (Preloader) Controller
 * Shows a branded loading animation on first page load within a session.
 * Uses sessionStorage to skip the animation on subsequent navigations
 * within the same tab. Depends on GSAP being loaded globally.
 */
document.addEventListener("DOMContentLoaded", function () {
    const PRELOADER_KEY = 'hora_preloader_shown';

    const preloaderEl = document.querySelector(".preloader_component");
    const header = document.querySelector(".site-header") || document.querySelector(".splash-header");
    const mainContent = document.querySelector("#MainContent") || document.querySelector(".main-content");

    /* ── Always-preload pages (homepage, product page) bypass session check ──
       Pages set data-always-preload="true" on <body> to force the animation every visit. */
    const alwaysPreload = document.body.dataset.alwaysPreload === 'true';

    /* ── Session Check ──
       sessionStorage persists across in-page navigations within a tab,
       but clears on tab close OR page refresh — giving us "show once per visit". */
    if (!alwaysPreload && sessionStorage.getItem(PRELOADER_KEY)) {
        if (preloaderEl) {
            preloaderEl.style.display = 'none';
        }
        document.body.classList.remove('preloader-active');
        if (header) {
            gsap.set(header, { opacity: 1, y: 0 });
        }
        if (mainContent) {
            gsap.set(mainContent, { opacity: 1 });
        }
        return;
    }

    /* ── First Load: Play Full Animation ── */
    sessionStorage.setItem(PRELOADER_KEY, '1');
    document.body.classList.add('preloader-active');

    if (header) {
        gsap.set(header, { opacity: 0, y: -20 });
    }
    if (mainContent) {
        gsap.set(mainContent, { opacity: 0 });
    }

    // Fake progress up to 90% to keep the user engaged while waiting for assets
    const counterEl = document.querySelector(".preloader_counter");
    let progress = { val: 0 };

      let loaderStarted = false;
        const triggerLoader = () => {
            if (loaderStarted) return;
            loaderStarted = true;
            if (fakeTween) fakeTween.kill();
            startLoader(progress.val);
        };

        // When all assets (images, fonts, etc.) are actually loaded, finish the animation
        window.addEventListener("load", triggerLoader);

    let fakeTween = gsap.to(progress, {
        duration: 3,
        val: 90,
        ease: "power1.out",
        onUpdate: function () {
            if (counterEl) counterEl.textContent = Math.round(progress.val) + "%";
        }
    });


    // Fallback if load event already fired or if max waiting time (8s) is reached
    if (document.readyState === 'complete') {
        triggerLoader();
    } else {
        setTimeout(triggerLoader, 3000);
    }
});

/**
 * Run the preloader animation sequence:
 * 1. Counter counts from current progress to 100%
 * 2. Background pattern scales up dramatically
 * 3. Counter & badge fade out
 * 4. Main content becomes visible
 * 5. Preloader fades out, header animates in
 */
function startLoader(startVal = 0) {
    const counterEl = document.querySelector(".preloader_counter");
    const bgEl = document.querySelector(".preloader_background");
    const preloaderEl = document.querySelector(".preloader_component");
    const badgeEl = document.querySelector(".preloader_badge");
    const mainContent = document.querySelector("#MainContent") || document.querySelector(".main-content");

    if (!counterEl || !preloaderEl) {
        console.warn("Preloader elements not found");
        return;
    }

    const tl = gsap.timeline();

    /* Step 1: Animate percentage counter from current value to 100% */
    tl.to({ val: startVal }, {
        duration: 0.8,
        val: 100,
        ease: "power2.inOut",
        onUpdate: function () {
            counterEl.textContent = Math.round(this.targets()[0].val) + "%";
        }
    });

    /* Step 2: Scale background pattern */
    if (bgEl) {
        tl.to(bgEl, {
            duration: 0.8,
            scale: 8,
            ease: "expo.inOut"
        }, "-=0.25");
    }

    /* Step 3: Fade out counter & badge */
    tl.to([counterEl, badgeEl], {
        duration: 0.8,
        opacity: 0,
        zIndex: -1
    }, "-=0.35");

    /* Step 4: Reveal main content */
    if (mainContent) {
        tl.set(mainContent, { opacity: 1 }, "-=0.2");
    }

    /* Step 5: Fade out preloader, then animate header in */
    tl.to(preloaderEl, {
        duration: 0.5,
        opacity: 0,
        ease: "power2.out",
        onComplete: () => {
            preloaderEl.style.display = "none";
            document.body.classList.remove('preloader-active');
            document.body.style.overflow = "";

            const header = document.querySelector(".site-header") || document.querySelector(".splash-header");
            if (header) {
                gsap.to(header, {
                    opacity: 1,
                    y: 0,
                    duration: 0.1,
                });
            }
        }
    }, "<");
}
